export const COURSES_TYPES = {
  FULLSTACK: "fullstack",
  ONDEMAND: "ondemand",
  LIVE_COURSES: "live-courses",
};